<template>
  <BaseNumberInput
    v-bind="$attrs"
    :hide-details="hideDetails"
    :value="value"
    :is-raw-format="isRawFormat"
    :format-type="NumberInputEnum.integer"
    @input="$emit('input', $event)"
  />
</template>

<script lang="ts">
import mixins from 'vue-typed-mixins';

import { NumberInputMixin } from '@/bundles/Common/mixins/NumberInputMixin';

import BaseNumberInput from '@/bundles/Common/components/inputs/BaseNumberInput.vue';

export default mixins(NumberInputMixin).extend({
  name: 'IntegerInput',

  components: { BaseNumberInput },

  props: {
    isRawFormat: Boolean,
  }
});
</script>
